/** @jsx jsx */
import { forwardRefWithAs, PropsWithAs } from "@eworkit/iris";
import { MenuItem, MenuItemProps } from "reakit/Menu";
import { jsx } from "theme-ui";

interface DropdownMenuItemComponentProps extends MenuItemProps {}

const DropdownMenuItemComponent = (
  props: PropsWithAs<DropdownMenuItemComponentProps, "button">,
  forwardedRef: React.Ref<HTMLButtonElement>,
) => {
  const { as = "button", children, ...rest } = props;

  return (
    <MenuItem
      {...rest}
      as={as}
      ref={forwardedRef}
      aria-label="dropdown-menu-item"
      sx={{
        appearance: "none",
        fontFamily: "body",
        fontWeight: "normal",
        fontSize: "p-md",
        lineHeight: "p-md",
        border: "none",
        width: "100%",
        display: "flex",
        alignItems: "center",
        bg: "transparent",
        p: "sm",
        outline: "none",

        "&:not([disabled])": {
          cursor: "pointer",

          "&:hover": {
            bg: "n20",
          },

          "&:focus": {
            outline: "none",
            bg: "n50",
          },
        },
      }}>
      {children}
    </MenuItem>
  );
};

export type DropdownMenuItemProps = PropsWithAs<DropdownMenuItemComponentProps, "button">;
export const DropdownMenuItem = forwardRefWithAs<DropdownMenuItemComponentProps, "button">(DropdownMenuItemComponent);
